import React from "react";
import { Typography } from "@mui/material";
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import {
  PasswordRequirementsList,
  RequirementItem,
  RequirementIcon,
  RequirementText,
} from "./authStyles";

const items = [
  { key: "minLength", label: "At least 8 characters" },
  { key: "hasNumber", label: "Contains a number" },
  { key: "hasSymbol", label: "Contains a symbol" },
  { key: "passwordsMatch", label: "Passwords match" },
];

const PasswordRequirementsChecklist = ({ requirements }) => {
  return (
    <PasswordRequirementsList>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Password Requirements:
      </Typography>
      {items.map(({ key, label }) => (
        <RequirementItem key={key}>
          <RequirementIcon>
            {requirements[key] ? (
              <CheckCircle
                sx={{ color: "success.main", fontSize: "20px" }}
              />
            ) : (
              <RadioButtonUnchecked
                sx={{ color: "text.disabled", fontSize: "20px" }}
              />
            )}
          </RequirementIcon>
          <RequirementText primary={label} />
        </RequirementItem>
      ))}
    </PasswordRequirementsList>
  );
};

export default PasswordRequirementsChecklist;
